import React from 'react';
import Input from './Input';
import EditIcon from '../../../../images/products/edit-blue.svg';
import TickIcon from '../../../../images/common/tick-green.svg';
import CrossIcon from '../../../../images/products/cross-red.svg';
import { CustomLabel, FlexContainer } from '../styles';
import styled from 'styled-components';

type IProps = {
  value: string;
  isEdit: boolean;
  onEditClick: () => void;
  onSaveClick: () => void;
  onCancelClick: () => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
};
const EditableFieldWrapper = styled(FlexContainer)`
  align-items: center;
  gap: 10px;
  img {
    &.desc-tick-icon {
      height: 17px !important;
      width: 17px !important;
      cursor: pointer !important;
    }
    &.desc-cross-icon {
      height: 15px !important;
      width: 15px !important;
      cursor: pointer !important;
    }
    &.pay-set-edit-icon {
      /* margin-left: 10px !important; */
      height: 15px !important;
      width: 25px !important;
      margin-bottom: 0px !important;
      cursor: pointer !important;
    }
  }
`;

const EditableField: React.FC<IProps> = ({
  value,
  isEdit,
  onEditClick,
  onSaveClick,
  onCancelClick,
  onChange,
  placeholder,
}) => {
  return (
    <EditableFieldWrapper>
      {isEdit ? (
        <>
          <Input value={value} type="text" onChange={onChange} placeholder={placeholder || 'Enter value'} />
          <FlexContainer alignItems="center" spacing={12}>
            <img src={TickIcon} onClick={onSaveClick} alt="Save" className="desc-tick-icon" />
            <img src={CrossIcon} onClick={onCancelClick} alt="Cancel" className="desc-cross-icon" />
          </FlexContainer>
        </>
      ) : (
        <>
          {value && <CustomLabel lineHeight="40px">{value}</CustomLabel>}

          <img src={EditIcon} className="pay-set-edit-icon" onClick={onEditClick} alt="Edit" />
        </>
      )}
    </EditableFieldWrapper>
  );
};

export default EditableField;
